import { request } from './instance';
export const FormatAPI = {
  getAll: async () => {
    const response = await request({
      url: 'v1/formats',
      method: 'GET',
    });

    return response.data.data;
  },
};
